
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Input extends Vue {
  @Prop(String) public readonly label!: string;
  @Prop(String) public readonly type!: string;
  @Prop(String) private readonly model!: string;
  @Prop(Boolean) public readonly disabled!: boolean;
  @Prop(String) public readonly icon!: string;
  @Prop(String) public readonly hint!: string;

  public input = '';

  public inputChanged(val) {
    this.input = val.replace(/[^\d.]|\.(?=.*\.)/g, '');
  }
  // //
  public addValue() {
    if (
      !isNaN(parseFloat(this.input)) &&
      Number(this.input) >= 0 &&
      Number(this.input) <= 9999999 &&
      this.input.indexOf('.') === -1
    ) {
      this.$emit('add', this.model, [this.input.trim()]);
      this.input = '';
    }
  }

  public blur() {
    this.input = '';
  }
}
